export const SEED_NAMESPACES = Object.freeze([
  "scene/v1",
  "game/solo/v1",
  "game/word-tending/v1",
  "audio/v1",
  "availability/demo-staggered/v1",
] as const);

export type SeedNamespace = (typeof SEED_NAMESPACES)[number];
export type SeedSource = string | number;

const FNV_OFFSET_BASIS = 0x811c9dc5;
const FNV_PRIME = 0x01000193;

export function deriveSeed(namespace: SeedNamespace, source: SeedSource): number {
  if (typeof source === "number" && !Number.isFinite(source)) {
    throw new RangeError("Numeric seed source must be finite");
  }
  let hash = FNV_OFFSET_BASIS;
  const bytes = new TextEncoder().encode(`${namespace}\0${String(source)}`);
  for (const byte of bytes) hash = Math.imul(hash ^ byte, FNV_PRIME) >>> 0;
  return hash;
}
